import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { DialogRef } from '@app/core/services/dialog-ref';
import { DIALOG_DATA } from '@app/core/services/dialog-token';
import { PollDialogModel } from '@app/_api/model';

@Component({
  selector: 'if-poll-overlay-dialog',
  templateUrl: './poll-overlay-dialog.html',
  imports: [NgIcon],
  viewProviders: [provideIcons({ heroXMark })],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class PollOverlayDialogComponent {
  protected readonly safeLink?: SafeResourceUrl;
  protected readonly data = inject<PollDialogModel>(DIALOG_DATA);

  private readonly dialogRef = inject(DialogRef);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    const msFormId = this.data?.poll?.msFormId;
    const baseUrl = this.data?.poll?.baseUrl;
    if (!msFormId || !baseUrl) return;

    const url = URL.parse(msFormId, baseUrl);
    url?.searchParams?.set('embed', 'true');
    if (!url) return;

    this.safeLink = this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
  }

  protected close() {
    this.dialogRef.close(false);
  }
}
